import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { getVideogames, getGenres, filterByGenre, filterByName, filterByCreated } from "../actions"
import Card from './Card'
import style from "./home.module.css"
import Loading from './Loading'
import Paginate from './Paginate'
import SearchBar from './SearchBar'


function Home() {
  const dispatch = useDispatch()
  const allVideogames = useSelector(state => state.videogames)
  const genres = useSelector(state => state.genres)
  const loading = useSelector(state => state.loading)

  useEffect(() => {
    dispatch(getVideogames())
    dispatch(getGenres())
  }, [])

  const [currentPage, setCurrentPage] = useState(1)
  const videogamesPage = 15
  const lastVideogame = currentPage * videogamesPage
  const firstVideogame = lastVideogame - videogamesPage
  const currentVideogames = allVideogames.slice(firstVideogame, lastVideogame)
  const paginate = (page) => {
    setCurrentPage(page)
  }
  const handleGenre = (e) => {
    dispatch(filterByGenre(e.target.value))
    setCurrentPage(1)
  }
  const handleCreated = (e) => {
    dispatch(filterByCreated(e.target.value))
    setCurrentPage(1)
  }

  const [order, setOrder] = useState("")
  const handleOrdering = (e) => {
    dispatch(filterByName(e.target.value))
    setCurrentPage(1)
    setOrder(`Order: ${e.target.value}`)
  }


  return (
    <div >
      {loading ? <Loading /> : null}
      <div className={style.navcontainer}>
        <h1>Videogames APP</h1>
        <div className={style.filtercontainer}>
          <div className={style.selectors}>
            <p className={style.text}>Filter by Genre</p>
            <select onChange={handleGenre}>
              <option value="All">All</option>
              {
                genres && genres.map((genre) => (
                  <option key={genre.id} value={genre.name}>{genre.name}</option>
                ))
              }
            </select>
          </div>
          <div className={style.selectors}>
            <p className={style.text}>Filter by Created</p>
            <select onChange={handleCreated}>
              <option value="All">All</option>
              <option value="db">Created by user</option>
              <option value="api">Videogame from API</option>
            </select>
          </div>
          <div className={style.selectors}>
            <p className={style.text}>Order by name</p>
            <select onChange={handleOrdering}>
              <option selected disabled>Choose an order</option>
              <option value="ascending">Ascending</option>
              <option value="descending">Descending</option>
            </select>
          </div>
          <SearchBar />
        </div>
      </div>

      <Paginate videogamesPage={videogamesPage} allVideogames={allVideogames.length} paginate={paginate} currentPage={currentPage} />
      {currentVideogames.length < 1 ? <p className={style.novideogames}>There are no videogames</p> : null}
      <div className={style.gamegrid}>
        {
          currentVideogames && currentVideogames.map(videogame => <Card key={videogame.id} id={videogame.id} name={videogame.name} image={videogame.image} genres={videogame.genres} rating={videogame.rating} />
          )
        }

      </div>
    </div>
  )
}

export default Home